import request from "@/common/request.js";


/**
 * 账号登陆
 */
export const loginByUserInfo = (param) => {
    return request.post("/village/loginController/login", param).then(response => {
        return response;
    }).catch(function (error) {
        console.log(error)
    });
};

/**
 * 账号详情
 */
export const userInfo = (param) => {
    // return request.get("/village/base/userInfo", param).then(response => {
    return request.get("/village/web/sysUser/userInfo", param).then(response => {
        return response.data;
    }).catch(function (error) {
        console.log(error)
    });
}

/**
 * 获取权限
 */
export const getPermissions = (param) => {
    return request.get("/village/web/sysMenu/getMenuMetas", param).then(response => {
        // return request.get("/village/loginController/showYourPermissions", param).then(response => {
        return response.data;
    }).catch(function (error) {
        console.log(error)
    });
}

// 动态表单模版
export const getTemplates = (url, param) => {
    return request.post5(url, param).then(response => {
        // return request.get("/village/loginController/showYourPermissions", param).then(response => {
        return response.data;
    }).catch(function (error) {
        console.log(error)
    });
}

